module.exports = __webpack_public_path__ + "static/media/whiteheadphones.4ffb4033.svg";